const Extended = {
  isIE: () => {
    return navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("rv:") > -1;
  }
};

export default Extended;
